<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="sort-icon__none">
      <path d="M11.3335 2V14"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
      <path d="M6.66675 12L4.66675 14L2.66675 12"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
      <path d="M4.66675 14V2"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
      <path d="M13.3335 4L11.3335 2L9.3335 4"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
    </g>
    <g class="sort-icon__asc">
      <path d="M11.3335 14V2"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
      <path d="M13.3335 4L11.3335 2L9.3335 4"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
    </g>
    <g class="sort-icon__desc">
      <path d="M4.66675 2V14"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
      <path d="M6.66675 12L4.66675 14L2.66675 12"
            stroke="#595A5B"
            stroke-width="1.5"
            stroke-linecap="round"
      />
    </g>
  </svg>
</template>
